import classes from './style/skills.module.css'
import img from '../img/wave.svg'

const Skills = () => {
    return (
        <div className={classes.skillsContainer}>
            <h1 className='title'>
                skills
            </h1>
            <p className='subTitle color1'><span className='subTitleBefore'> /* </span> My technical skills <span className='subTitleAfter'> */ </span></p>
            <div className={classes.container}>
                <div className={classes.skillChiled}>
                    <h1>Software Engineering</h1>
                    <div className={classes.skillafter}>
                        <p>
                            Experienced in functional and object-oriented programming languages like C++, Python, and JavaScript.
                        </p>
                    </div>
                </div>
                <div className={classes.skillChiled}>
                    <h1>Frontend Development</h1>
                    <div className={classes.skillafter}>
                        <p>
                            Passionate about creating intuitive user interfaces and exceptional user experiences. 2+ years of experience in HTML, CSS, and JavaScript, with expertise in React framework.
                        </p>
                    </div>
                </div>

                <div className={classes.skillChiled}>
                    <h1>Backend Development</h1>
                    <div className={classes.skillafter}>
                        <p>
                            Proficient in designing APIs and databases using Node.js, Express.js, MongoDB, and MySQL.
                        </p>
                    </div>
                </div>
                <div className={classes.skillChiled}>
                    <h1>DevOps</h1>
                    <div className={classes.skillafter}>
                        <p>
                            Skilled in implementing DevOps practices for streamlined software development and deployment. Proficient in CI/CD with Jenkins and CircleCI. Experienced in Docker, AWS CloudFormation, Ansible, and Prometheus.
                        </p>
                    </div>
                </div>
            </div>
            <div className='reverseWave'>
                <img src={img} alt="wave" />
            </div>
            <div className={classes.bubbels}>

            </div>

        </div>
    )
}

export default Skills
